import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "./seoConstants";

/** Route-level meta description; truncated for SERP limits (head-only). */
const RouteMetaDescription = () => {
  const { pathname } = useLocation();
  const metaDescription = useMemo(
    () => getSeoForPath(pathname).metaDescription,
    [pathname]
  );

  if (!metaDescription) return null;

  return (
    <Helmet>
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};

export default RouteMetaDescription;
